export default {
  state: {
    resultList: [],//结果库
    resultSelection: {},//当前勾选的值
    isResult: false,//判断是否点击结果集,
  },
  mutations: {
    deleteResult(state, id) {
      let resultCurrentList = state.resultList;
      state.resultList = resultCurrentList.filter(item => item.ID !== id)
    },
    deleteResultField(state, row) {
      let resultCurrentList = state.resultList;
      state.resultList = resultCurrentList.filter(item => item[row.filed] !== row.id)
    },
    addResult(state, row) {
      console.log('row:',row)
      let resultCurrentList = state.resultList;
      let key = row.row.ID;
      let filed = 'ID';
      if (row.key) {
        key = row.key;
        filed = row.filed;
      }
      if (resultCurrentList.filter(item => item[filed] === key).length === 0 && row.bol) {
        // console.log('添加')
        resultCurrentList.push(row.row)
        state.resultList = resultCurrentList;
      } else if (resultCurrentList.filter(item => item[filed] === key).length !== 0 && !row.bol) {
        // console.log('移除')
        // 				let index = resultCurrentList.indexOf(row.row)
        // 				resultCurrentList.splice(index, 1)
        // state.resultList=resultCurrentList;
        // console.log(resultCurrentList.filter(item => item.ID !== key),'返回json')
        state.resultList = resultCurrentList.filter(item => item[filed] !== key)
      }
    },
    setResult(state, resultList) {
      state.resultList = resultList;
    },
    setResultSelection(state, row) {
      console.log(row);
      console.log(state.resultList);
      
      state.resultSelection = row;
    },
    clearResult(state) {
      console.log("清空");
      
      state.resultList = [];
    }
  },
  actions: {

  }
}
